import { productsData } from "../productsData"
import { useLocation } from "react-router-dom"
import { useContext } from "react"
import { UserContext } from "../contexts/UserContext"
import { UserOrderRow } from "../components/account/UserOrderRow"
import "./userOrders.css"

export function UserOrders() {
    const location = useLocation()

   const userContextData = useContext(UserContext)
   const { user } = userContextData

   const statusPathWords = {
        Delivered: "deliveries",
        Returned: "returns",
        Cancelled: "cancellations",
        Pending: "pending"
   }

    return (
        <div className="my-orders">
            <h4 className="primary-text mb-5">My Orders</h4>

            <div className="rounded-1 orders-wrapper">
                <table className="my-orders-table table-header">
                    <tbody>
                        <tr className="">
                            <td className="">Order ID</td>
                            <td className="">Date</td>
                            <td>Items</td>
                            <td className="">Status</td>
                            <td className="text-end pe-5">Amount</td>
                        </tr>
                    </tbody>
                </table>

                {
                    user ?
                        location.pathname === "/account/orders" ?
                            user.orders.map((e, i) => (
                                <UserOrderRow key={i} order={e} />
                            ))
                            :
                            user.orders.filter(
                                a => statusPathWords[a.status] === location.pathname.split("/")[2]
                            ).map((e, i) => (
                                <UserOrderRow key={i} order={e} />
                            ))
                    :
                    ""
                }
            </div>
        </div>
    )
}